import { SetIsOpenSidebar } from '../actions/ActionTypes';
export function IsSidebarOpenReducer(state: boolean = false, payload) {
    switch (payload.type) {
        case SetIsOpenSidebar:
            return payload.data;
        default:
            return state;
    }
}
